module.exports = __webpack_public_path__ + "static/media/016.1cec255d.jpg";